import Cookies from 'js-cookie'
import Config from '../api/config'
const TokenKey = 'Admin-Token'
const rootDomain = Config.rootDomain

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  if (rootDomain) {
    return Cookies.set(TokenKey, token, { domain: rootDomain })
  } else {
    return Cookies.set(TokenKey, token)
  }
}

export function removeToken() {
  if (rootDomain) {
    return Cookies.remove(TokenKey, { domain: rootDomain })
  } else {
    return Cookies.remove(TokenKey)
  }
}

export function getCookie(key) {
  return Cookies.get(key)
}

export function setCookie(key, val) {
  return Cookies.set(key, val)
}

export function removeCookie(key) {
  return Cookies.remove(key)
}

export function getLocalStorage(key) {
  const item=localStorage.getItem(key)
    if(item=='undefined'||item=='null'){
      return null
    }
    return localStorage.getItem(key)
}

export function setLocalStorage(key, val) {
    return localStorage.setItem(key, val)
}

export function removeLocalStorage(key) {
 
    return localStorage.removeItem(key)
  
}



// WEBPACK FOOTER //
// ./src/utils/cache.js